import type * as type from "@vTypes";

/** `useRosterDisplayShiftColumns` 결과와 동일한 행 형태 */
export type RosterDisplayShiftChip = {
  id?: number | null;
  shift_id: string;
};

/**
 * 근무표 헤더 옆·하단에 쓰는 근무코드 색상 칩 (통계 열과 동일 소스)
 */
export function RosterShiftLegendChips({
  displayShifts,
  defaultShiftCode,
}: {
  displayShifts: RosterDisplayShiftChip[];
  defaultShiftCode: type.availableShifts[] | undefined;
}) {
  if (!displayShifts.length) return null;

  return (
    <div className="items-center flex gap-[5.7px]">
      {displayShifts.map((shift) => {
        const defaultShift = defaultShiftCode?.find(
          (s) =>
            (shift.id != null && s.id === shift.id) ||
            (shift.id == null && s.shift_id === shift.shift_id)
        );
        const color = defaultShift?.color ?? "#d6d6de";

        return (
          <div
            key={
              shift.id != null
                ? `shift-hdr-${shift.id}`
                : `shift-hdr-${shift.shift_id}`
            }
            className="rt_shiftCode"
            style={{ backgroundColor: color, borderRadius: "6px" }}
          >
            <span className="min-w-0 truncate">{shift.shift_id}</span>
          </div>
        );
      })}
    </div>
  );
}
